import { decodeQueryParams } from "../../../../../utils/EncodeDecodeQueryParams";

const extractUrlParams = async (location) => {
  let page = 1;
  let take = 20;
  let filter = null;
  let _filterValue = undefined;

  const urlParams = new URLSearchParams(location.search);
  const key = urlParams.get("key");

  if (key) {
    _filterValue = JSON.parse(await decodeQueryParams(key));
    page = _filterValue.page;
    take = _filterValue.take;

    _filterValue.dari = _filterValue.dari
      ? new Date(_filterValue.dari)
      : new Date();

    _filterValue.sampai = _filterValue.sampai
      ? new Date(_filterValue.sampai)
      : new Date();
  }

  return { page, take, filter, filterValue: _filterValue };
};

export default extractUrlParams;
